export const TAGS = {
    DROPPABLE: 'dnd-droppable',
    DRAGGABLE: 'dnd-draggable',
    DRAG_INTERACTIVE: 'dnd-draginteractive',
};
//# sourceMappingURL=tags.js.map